import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

import { DomainsResponseSuccess } from 'api';
import { useFetchContractorDirectory } from 'hooks';

function useDomainsQuery(
  options?: UseQueryOptions<DomainsResponseSuccess, Error>,
): UseQueryResult<DomainsResponseSuccess, Error> {
  const authorisedFetch = useFetchContractorDirectory();

  return useQuery<DomainsResponseSuccess, Error>(
    'domains',
    async () => {
      const response = await authorisedFetch(`/domains`, {
        method: 'GET',
      });

      return await response.json();
    },
    options,
  );
}

export default useDomainsQuery;
